<template>
  <template v-if="dossier[column.field] && dossier[column.field] !== '#######'">
    <Popover>
      <Float auto-placement :offset="2" :portal="true" composable>
        <FloatReference>
          <PopoverButton
            as="div"
            class="flex cursor-pointer items-center justify-center"
          >
            <BaseButton
              :color="
                internalNoteFields.includes(column.field)
                  ? 'primary'
                  : column.field === 'logged_activities_dashboard'
                    ? undefined
                    : 'warning'
              "
              :theme-color="
                column.field === 'logged_activities_dashboard'
                  ? 'bg-purple-500 border-purple-500 text-white'
                  : undefined
              "
              :icon="
                column.field === 'logged_activities_dashboard'
                  ? 'font-awesome'
                  : 'circle-info'
              "
              size="extra-small"
            />
          </PopoverButton>
        </FloatReference>
        <PopoverOverlay class="fixed inset-0 z-100 bg-black opacity-30" />
        <FloatContent>
          <PopoverPanel
            class="z-100 flex max-h-82 w-80 flex-col gap-2 overflow-hidden rounded-md border border-gray-200 bg-white p-2 text-left shadow-2xl"
          >
            <h1 class="shrink-0 text-base font-bold capitalize-first">
              {{ modalTitle }} :
            </h1>
            <div class="min-h-0 flex-1 overflow-y-auto text-xs font-medium">
              <div
                class="break-words whitespace-pre-wrap"
                v-html="dossier[column.field]"
              ></div>
            </div>
          </PopoverPanel>
        </FloatContent>
      </Float>
    </Popover>
  </template>
</template>
<script>
import {
  Popover,
  PopoverButton,
  PopoverOverlay,
  PopoverPanel
} from '@headlessui/vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { Float, FloatReference, FloatContent } from '@headlessui-float/vue'

export default {
  name: 'ModalComponent',
  components: {
    Float,
    FloatReference,
    FloatContent,
    BaseButton,
    Popover,
    PopoverButton,
    PopoverOverlay,
    PopoverPanel
  },
  props: {
    column: {
      type: [Array, Object],
      required: true
    },
    dossier: {}
  },
  computed: {
    internalNoteFields() {
      return ['dossier#properties#internal_notes', 'note_intern_dashboard']
    },
    modalTitle() {
      if (this.internalNoteFields.includes(this.column.field)) {
        return this.$t('attributes.internal_notes')
      }
      if (this.column.field === 'logged_activities_dashboard') {
        return this.$t('global.consignations')
      }
      return this.$h.getLocalizedLabel(
        this.column.label,
        this.$i18n.locale,
        this.$t('global.particularities')
      )
    }
  }
}
</script>
